import { schema } from 'normalizr';

export const ORDER = 'orders';

export const orderSchema = new schema.Entity(ORDER);
